import { useCapabilities } from '../../hooks/useCapabilities';
import { useModuleAccess } from '../../hooks/useModuleAccess';
import type { Lead } from '../../types';
import { projectDetailPath, projectDocumentEditorPathFromLabel } from '../../utils/projectRoutes';

/** URL-Parameter der Projektliste, der den Schnellstart „Neues Angebot“ öffnet (`?neuesAngebot=1`). */
export const OFFER_QUICK_START_PARAM = 'neuesAngebot';

/**
 * Schnellstart „Neues Angebot“ (Kunde wählen → Projekt + Angebot → Editor): nur mit Modul Angebote
 * und dem Recht, Projekte anzulegen. Solange `loaded` false ist, keine Entscheidung treffen.
 */
export function useOfferQuickStartAccess(): { loaded: boolean; allowed: boolean } {
  const { loaded: modulesLoaded, isEnabled } = useModuleAccess();
  const { loaded: capabilitiesLoaded, can } = useCapabilities();
  const loaded = modulesLoaded && capabilitiesLoaded;
  return { loaded, allowed: loaded && isEnabled('angebote') && can('web.projekte.edit') };
}

/** Ziel nach dem Anlegen: Editor des ersten Angebots; fehlt es, die Projektseite. */
export function offerQuickStartTargetPath(lead: Pick<Lead, 'id' | 'primary_offering_id'>): string {
  const offeringId = String(lead.primary_offering_id ?? '').trim();
  if (!offeringId) return projectDetailPath(lead);
  // `neu=1` wie bei „Dokument erstellen“: frisches Dokument statt eines vorhandenen öffnen.
  return `${projectDocumentEditorPathFromLabel(lead, 'Angebot', offeringId)}&neu=1`;
}
